module.exports = __webpack_public_path__ + "img/粘贴3.a97edeed.svg";